var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "222.1%",
    height: "222.1%",
    x: "-61.1%",
    y: "-56.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "161.1%",
    height: "161.1%",
    x: "-30.5%",
    y: "-26.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1 0 0 0 0 0.730643363 0 0 0 0 0.564885433 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FECEAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FCA072"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 23.75,
    cy: 23.75,
    r: 23.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M13.8878505,9.76773567 L1.77570093,9.76773567 C1.30841121,9.76773567 0.953271028,9.39844509 0.953271028,8.9552964 L0.953271028,8.9552964 L1.57009346,1.40330418 C1.57009346,0.941690962 1.94392523,0.590864917 2.39252336,0.590864917 C2.39252336,0.590864917 2.39252336,0.590864917 2.39252336,0.590864917 L13.2897196,0.590864917 C13.7570093,0.590864917 14.1121495,0.960155491 14.1121495,1.40330418 L14.1121495,1.40330418 L14.728972,8.9552964 C14.7102804,9.39844509 14.3364486,9.76773567 13.8878505,9.76773567 L13.8878505,9.76773567 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.862 10.308)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EADFC5",
    d: "M0,16.414966 L19.7570093,16.414966 L19.7570093,16.414966 L19.7570093,20.1263362 C19.7570093,20.6618076 19.3084112,21.1049563 18.7663551,21.1049563 L1.00934579,21.1049563 C0.448598131,21.1049563 0.0186915888,20.6618076 0.0186915888,20.1078717 L0.0186915888,20.1078717 L0,16.414966 L0,16.414966 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#2A2F35",
    points: "18.449 19.462 18.449 20.366 1.364 20.366 1.364 19.462"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5E3E3",
    points: "8.299 19.48 9.514 18.723 8.523 19.203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5E3E3",
    points: "12.056 23.025 12.075 23.21 12.841 22.785"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E3E3",
    d: "M5.30841121,15.6763848 C5.53271028,15.0116618 6.52336449,14.6054422 6.87850467,14.7531584 L16.1308411,16.2487852"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E5E3E3",
    transform: "translate(6.206 17.071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.04672897,0.820741227 C7.23364486,0.248340838 8.09345794,-0.102485206 8.93457944,0.0267664943 C9.77570093,0.156018195 10.317757,0.728418584 10.1308411,1.30081897 C9.94392523,1.87321936 9.08411215,2.22404541 8.24299065,2.09479371 C7.40186916,1.965542 6.85981308,1.37467709 7.04672897,0.820741227 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.308 1.652 0 3.258 .15 3.664"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.636 5.714 5.234 6.157 5.364 6.471"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.869 6.139 6.411 6.379 6.935 6.286 6.636 5.714"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.243 14.716)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.8971963,12.260447 L0.635514019,12.260447 C0.280373832,12.260447 0,11.9834791 0,11.6326531 L0.61682243,0.627793975 C0.61682243,0.27696793 0.897196262,0 1.25233645,0 L14.2803738,0 C14.635514,0 14.9158879,0.27696793 14.9158879,0.627793975 L15.5327103,11.6326531 C15.5140187,11.9834791 15.2336449,12.260447 14.8971963,12.260447 Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5E3E3",
    points: "2.785 5.059 2.579 5.447 3.178 5.318 3.383 5.706 3.907 5.429 3.664 4.727",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5E3E3",
    points: "2.579 5.447 3.664 4.727 2.785 5.059",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5E3E3",
    points: "6.28 4.487 6.056 4.764 6.654 4.635 6.822 5.299 7.57 4.708 7.271 4.007",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EFEFEF",
    points: "5.72 4.967 6.636 4.044 5.85 4.653",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EFEFEF",
    points: "10.561 7.866 10.636 8.032 11.252 7.515",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E3E3",
    d: "M14.1495327,9.76773567 L1.51401869,9.76773567 C1.19626168,9.76773567 0.953271028,9.52769679 0.953271028,9.21379981 L1.57009346,1.14480078 C1.57009346,0.83090379 1.81308411,0.590864917 2.13084112,0.590864917 L13.5327103,0.590864917 C13.8504673,0.590864917 14.0934579,0.83090379 14.0934579,1.14480078 L14.7102804,9.21379981 C14.7102804,9.50923226 14.4485981,9.76773567 14.1495327,9.76773567 Z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88C7D8",
    d: "M14.2429907,9.76773567 L1.40186916,9.76773567 C1.14018692,9.76773567 0.934579439,9.56462585 0.934579439,9.30612245 L1.55140187,1.03401361 C1.55140187,0.775510204 1.75700935,0.572400389 2.01869159,0.572400389 L13.6448598,0.572400389 C13.9065421,0.572400389 14.0934579,0.775510204 14.0934579,1.03401361 L14.7102804,9.32458698 C14.6915888,9.56462585 14.5046729,9.76773567 14.2429907,9.76773567 Z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C8EB9",
    d: "M14.7102804,5.77939747 L14.7102804,9.25072886 C14.7102804,9.54616132 14.4672897,9.76773567 14.1869159,9.76773567 L1.47663551,9.76773567 C1.17757009,9.76773567 0.953271028,9.52769679 0.953271028,9.25072886 L1.21628838,5.77939747 L14.7102804,5.77939747 Z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA7B6C",
    d: "M10.0186916,2.67735666 C10.0186916,2.08649174 10.728972,1.62487852 11.6074766,1.62487852 C12.4859813,1.62487852 13.1962617,2.10495627 13.1962617,2.67735666 C13.1962617,3.24975705 12.4859813,3.72983479 11.6074766,3.72983479 C10.728972,3.72983479 10.0186916,3.24975705 10.0186916,2.67735666 Z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A4854",
    points: ".935 7.404 3.364 5.281 4.224 6.463 6.636 4.044 10.262 8.438 11.252 7.515 13.607 10.063 .748 10.285",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5B5966",
    points: "6.636 4.044 3.963 6.112 4.224 6.463",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5B5966",
    points: "11.252 7.515 10.019 8.143 10.262 8.438",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B5966",
    d: "M0.747663551,7.97667638 L3.36448598,5.2808552 C1.9943004,6.16033641 1.27823453,6.6188722 1.21628838,6.65646259 C1.15434224,6.69405297 0.998133958,6.76483366 0.747663551,6.86880466 L0.747663551,8.03206997",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "10.636 8.032 11.252 8.198 11.72 8.032 11.252 7.515",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "2.636 5.742 2.561 6.149 3.103 5.927 3.421 6.278 3.85 5.927 3.364 5.281",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E2E2E2",
    points: "2.561 6.149 3.364 5.281 2.636 5.742",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "5.85 4.653 5.72 4.967 6.262 4.745 6.636 5.373 7.178 4.69 6.636 4.044",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8878505,9.76773567 L1.77570093,9.76773567 C1.30841121,9.76773567 0.953271028,9.39844509 0.953271028,8.9552964 L0.953271028,8.9552964 L1.57009346,1.40330418 C1.57009346,0.941690962 1.94392523,0.590864917 2.39252336,0.590864917 C2.39252336,0.590864917 2.39252336,0.590864917 2.39252336,0.590864917 L13.2897196,0.590864917 C13.7570093,0.590864917 14.1121495,0.960155491 14.1121495,1.40330418 L14.1121495,1.40330418 L14.728972,8.9552964 C14.7102804,9.39844509 14.3364486,9.76773567 13.8878505,9.76773567 L13.8878505,9.76773567 Z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E2E2E2",
    points: "12.879 22.748 12.486 22.748 13.495 22.231"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E2E2E2",
    points: "7.963 19.683 8.879 18.76 8.093 19.369"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.103,
    height: 1,
    x: 1.364,
    y: 18.76,
    fill: "#2A2F35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.103,
    height: 1,
    x: 1.364,
    y: 18.04,
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.757,
    height: 1.126,
    y: 15.289,
    fill: "#EAD9B7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2E2C7",
    points: "18.598 12.427 1.159 12.427 0 15.289 19.757 15.289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34383A",
    d: "M3.43925234,1.49562682 L6.35514019,1.49562682 C7.00934579,1.49562682 7.53271028,2.01263362 7.53271028,2.65889213 L7.53271028,5.07774538 C7.53271028,5.72400389 7.00934579,6.24101069 6.35514019,6.24101069 L3.43925234,6.24101069 C2.78504673,6.24101069 2.26168224,5.72400389 2.26168224,5.07774538 L2.26168224,2.65889213 C2.24299065,2.01263362 2.78504673,1.49562682 3.43925234,1.49562682 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484B4C",
    d: "M3.43925234,2.04956268 L6.35514019,2.04956268 C6.72897196,2.04956268 7.04672897,2.34499514 7.04672897,2.73275024 L7.04672897,5.35471331 C7.04672897,5.72400389 6.74766355,6.03790087 6.35514019,6.03790087 L3.43925234,6.03790087 C3.06542056,6.03790087 2.74766355,5.74246842 2.74766355,5.35471331 L2.74766355,2.73275024 C2.74766355,2.34499514 3.04672897,2.04956268 3.43925234,2.04956268 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3D3D",
    d: "M3.42056075,2.04956268 C3.04672897,2.06802721 2.72897196,2.36345967 2.71028037,2.73275024 L2.71028037,5.33624879 C2.72897196,5.70553936 3.04672897,6.00097182 3.42056075,6.01943635 L3.42056075,2.04956268 Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34383A",
    d: "M2.52336449,2.91739553 L17.2336449,2.91739553 C18,2.91739553 18.6168224,3.52672498 18.6168224,4.28377065 L18.6168224,4.28377065 L18.6168224,11.3372206 L18.6168224,11.3372206 L1.1588785,11.3372206 L1.1588785,11.3372206 L1.1588785,4.28377065 C1.1588785,3.52672498 1.75700935,2.91739553 2.52336449,2.91739553 L2.52336449,2.91739553 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E2C7",
    d: "M2.52336449,3.43440233 L17.2336449,3.43440233 C18,3.43440233 18.6168224,4.04373178 18.6168224,4.80077745 L18.6168224,4.80077745 L18.6168224,11.8542274 L18.6168224,11.8542274 L1.1588785,11.8542274 L1.1588785,11.8542274 L1.1588785,4.80077745 C1.1588785,4.04373178 1.75700935,3.43440233 2.52336449,3.43440233 L2.52336449,3.43440233 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAD9B7",
    d: "M2.41121495,4.00680272 L17.3457944,4.00680272 C18.0373832,4.00680272 18.6168224,4.56073858 18.6168224,5.26239067 L18.6168224,12.4266278 L18.6168224,12.4266278 L1.1588785,12.4266278 L1.1588785,12.4266278 L1.1588785,5.26239067 C1.1588785,4.57920311 1.71962617,4.00680272 2.41121495,4.00680272 C2.41121495,4.00680272 2.41121495,4.00680272 2.41121495,4.00680272 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.019,
    cy: 8.457,
    fill: "#3B3B3A",
    rx: 3.402,
    ry: 3.361
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.019,
    cy: 8.457,
    fill: "#0C150E",
    rx: 2.972,
    ry: 2.936
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M10.0373832,5.65014577 C10.0373832,5.65014577 10.0186916,5.63168124 10.0373832,5.65014577 C8.5046729,5.59475219 7.25233645,6.79494655 7.21495327,8.29057337 C7.21495327,8.3090379 7.21495327,8.34596696 7.21495327,8.36443149 L12.8037383,8.36443149 C12.8224299,6.86880466 11.6074766,5.65014577 10.0934579,5.65014577 C10.0747664,5.65014577 10.0560748,5.65014577 10.0373832,5.65014577 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343435",
    d: "M12.8224299,8.38289602 L7.23364486,8.38289602 L7.23364486,8.41982507 C7.23364486,9.95238095 8.48598131,11.1895044 10.0373832,11.1895044 L10.0373832,11.1895044 C10.0373832,11.1895044 10.0560748,11.1895044 10.0560748,11.1895044 C11.6074766,11.1710398 12.8411215,9.93391642 12.8411215,8.40136054 L12.8224299,8.38289602 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 8.457,
    fill: "#3B3B3A",
    rx: 2,
    ry: 1.976
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.056,
    cy: 8.512,
    fill: "#FFF",
    opacity: 0.4,
    rx: 1.29,
    ry: 1.274
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.3457944,8.40136054 C11.3271028,7.69970845 10.728972,7.16423712 10.0186916,7.18270165 C9.34579439,7.20116618 8.80373832,7.73663751 8.78504673,8.40136054 L11.3457944,8.40136054 Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A2F35",
    d: "M4.18691589,7.58892128 L4.18691589,7.58892128 C3.38317757,7.58892128 2.74766355,6.94266278 2.74766355,6.16715258 L2.74766355,6.16715258 C2.74766355,5.37317784 3.40186916,4.74538387 4.18691589,4.74538387 L4.18691589,4.74538387 C4.99065421,4.74538387 5.62616822,5.39164237 5.62616822,6.16715258 L5.62616822,6.16715258 C5.62616822,6.94266278 4.99065421,7.58892128 4.18691589,7.58892128 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.18691589,7.2750243 L4.18691589,7.2750243 C3.57009346,7.2750243 3.06542056,6.77648202 3.06542056,6.16715258 L3.06542056,6.16715258 C3.06542056,5.55782313 3.57009346,5.05928086 4.18691589,5.05928086 L4.18691589,5.05928086 C4.80373832,5.05928086 5.30841121,5.55782313 5.30841121,6.16715258 L5.30841121,6.16715258 C5.30841121,6.77648202 4.80373832,7.25655977 4.18691589,7.2750243 Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M17.0093458,10.0447036 C17.0093458,10.6724976 16.4859813,11.1895044 15.8504673,11.1895044 C15.2149533,11.1895044 14.6915888,10.6724976 14.6915888,10.0447036 C14.6915888,9.41690962 15.2149533,8.89990282 15.8504673,8.89990282 C15.8504673,8.89990282 15.8504673,8.89990282 15.8504673,8.89990282 C16.4859813,8.91836735 17.0093458,9.41690962 17.0093458,10.0447036 C17.0093458,10.0447036 17.0093458,10.0447036 17.0093458,10.0447036 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D1D3",
    d: "M16.8037383,10.0447036 C16.8037383,10.5617104 16.3738318,10.9863946 15.8504673,10.9863946 C15.3271028,10.9863946 14.8971963,10.5617104 14.8971963,10.0447036 C14.8971963,9.52769679 15.3271028,9.10301263 15.8504673,9.10301263 C15.8504673,9.10301263 15.8504673,9.10301263 15.8504673,9.10301263 C16.3738318,9.10301263 16.8037383,9.52769679 16.8037383,10.0447036 Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34383A",
    d: "M14.4299065,0 L17.1401869,0 C17.4392523,0 17.6635514,0.240038873 17.6635514,0.517006803 L17.6635514,2.7696793 C17.6635514,3.06511176 17.4205607,3.2866861 17.1401869,3.2866861 L14.4299065,3.2866861 C14.1308411,3.2866861 13.9065421,3.04664723 13.9065421,2.7696793 L13.9065421,0.517006803 C13.9065421,0.240038873 14.1308411,0 14.4299065,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484B4C",
    d: "M14.4859813,0.27696793 L17.0841121,0.27696793 C17.4018692,0.27696793 17.6635514,0.535471331 17.6635514,0.867832847 L17.6635514,2.95432459 C17.6635514,3.26822157 17.4018692,3.5451895 17.0841121,3.5451895 L14.4859813,3.5451895 C14.1682243,3.5451895 13.9065421,3.2866861 13.9065421,2.95432459 L13.9065421,0.867832847 C13.9065421,0.535471331 14.1682243,0.27696793 14.4859813,0.27696793 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.1401869,0.941690962 L16.4299065,0.941690962 C16.7476636,0.941690962 17.0093458,1.20019436 17.0093458,1.53255588 L17.0093458,2.30806608 C17.0093458,2.62196307 16.7476636,2.898931 16.4299065,2.898931 L15.1401869,2.898931 C14.8224299,2.898931 14.5607477,2.6404276 14.5607477,2.30806608 L14.5607477,1.53255588 C14.5420561,1.21865889 14.8224299,0.941690962 15.1401869,0.941690962 Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M17.0093458,1.88338192 L17.0093458,2.28960155 C17.0093458,2.60349854 16.7476636,2.88046647 16.4299065,2.88046647 L15.1401869,2.88046647 C14.8224299,2.88046647 14.5607477,2.62196307 14.5607477,2.28960155 L14.5420561,1.88338192 L17.0093458,1.88338192 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3B3A",
    d: "M16.7476636,7.33041788 L14.9158879,7.33041788 C14.411215,7.33041788 14,6.92419825 14,6.42565598 L14,6.42565598 C14,5.9271137 14.411215,5.52089407 14.9158879,5.52089407 L16.7476636,5.52089407 C17.2523364,5.52089407 17.6635514,5.9271137 17.6635514,6.42565598 L17.6635514,6.42565598 C17.6635514,6.90573372 17.2523364,7.31195335 16.7476636,7.33041788 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.85,
    height: 1.126,
    x: 1.925,
    y: 15.289,
    fill: "#EA7663"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FE8A71",
    points: "3.776 15.289 1.925 15.289 3.084 12.445 4.916 12.445"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C1D1C3",
    points: "6.262 15.289 4.43 15.289 5.589 12.445 7.402 12.445"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.85,
    height: 1.126,
    x: 4.43,
    y: 15.289,
    fill: "#B4BFB5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.757,
    height: 1.773,
    y: 16.415,
    fill: "#EADFC5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvIcon);
export default __webpack_public_path__ + "static/media/PV-icon.4ae159b78f60fceeacfbffb20b8c1e80.svg";
export { ForwardRef as ReactComponent };